/**
 * El ingreso con Google, uno solo para el ERP y el portal.
 *
 * La URL de autorización la arma el BACKEND (`/auth/sso/google/start/`): genera
 * un `state` aleatorio, lo guarda y lo deja en una cookie de este navegador, y
 * el callback lo exige. Antes el `state` era `base64(origen)` armado acá, sin
 * nada aleatorio, y una URL de callback con el código de otra persona dejaba a
 * quien la abría logueado en la cuenta ajena (CSRF de login, 2026-10-02).
 *
 * Con URI fija (staging/prod) Google vuelve al callback del backend; sin ella
 * (desarrollo) vuelve a `/auth/callback/google` de este origen y solo el ERP
 * tiene ese flujo, así que el portal no ofrece Google.
 */
import apiClient from '@/lib/apiClient'

export type AudienciaGoogle = 'erp' | 'portal'

export function redirectUriFija(): string | undefined {
  return (import.meta.env.VITE_OAUTH_REDIRECT_URI as string | undefined) || undefined
}

/** El portal solo ofrece Google si hay URI fija: sin ella no hay callback que lo atienda. */
export function googleDisponible(audiencia: AudienciaGoogle): boolean {
  return audiencia === 'erp' || !!redirectUriFija()
}

/** Pide al backend la URL de autorización (y la cookie del `state`) y navega a Google. */
export async function iniciarLoginGoogle(audiencia: AudienciaGoogle = 'erp'): Promise<void> {
  const { data } = await apiClient.post<{ url: string }>('/auth/sso/google/start/', {
    audience: audiencia,
    origin: window.location.origin,
  })
  window.location.href = data.url
}
